import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Wrench, Database, Cpu } from 'lucide-react';
import { apiGet, apiPost } from '../lib/api.js';
import toast from 'react-hot-toast';

export default function DevTools() {
  const { data: health } = useQuery({ queryKey: ['health'], queryFn: () => apiGet('/devtools/health'), refetchInterval: 5000 });
  const { data: db } = useQuery({ queryKey: ['dbstats'], queryFn: () => apiGet('/devtools/db-stats') });

  async function runAction(action) {
    try {
      const r = await apiPost('/devtools/run-action', { action });
      toast.success(r.message);
    } catch { toast.error('Failed'); }
  }

  return (
    <div className="space-y-4 max-w-[1500px] mx-auto">
      <header>
        <div className="text-civix-purpleSoft/80 uppercase tracking-[0.3em] text-xs flex items-center gap-2">
          <Wrench className="w-3 h-3"/>Superadmin
        </div>
        <h1 className="font-display text-3xl font-bold mt-1">DevTools</h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="panel p-5">
          <div className="font-display font-bold mb-3 flex items-center gap-2"><Cpu className="w-4 h-4"/>System Health</div>
          <div className="space-y-2 text-sm">
            <Row label="Database" ok={health?.db}/>
            <Row label="AI Provider" ok={health?.ai}/>
            <Row label="Twilio" ok={health?.twilio}/>
            <div className="text-xs text-white/50 mt-3">Uptime: {Math.round((health?.uptime || 0) / 60)}m</div>
            <div className="text-xs text-white/50">Node: {health?.nodeVersion}</div>
            <div className="text-xs text-white/50">Memory RSS: {Math.round((health?.memory?.rss || 0) / 1024 / 1024)}MB</div>
          </div>
        </div>

        <div className="panel p-5">
          <div className="font-display font-bold mb-3 flex items-center gap-2"><Database className="w-4 h-4"/>Database</div>
          <div className="text-sm">
            <div>Leads: <span className="gradient-text font-bold">{db?.stats?.leads?.toLocaleString() || 0}</span></div>
            <div>Agents: <span className="gradient-text font-bold">{db?.stats?.agents?.toLocaleString() || 0}</span></div>
            <div className="text-xs text-white/50 mt-3">Collections: {db?.stats?.collections?.length || 0}</div>
          </div>
        </div>
      </div>

      <div className="panel p-5">
        <div className="font-display font-bold mb-3">Maintenance Actions</div>
        <div className="flex gap-2 flex-wrap">
          <button onClick={() => runAction('reindex-leads')} className="btn-ghost">Reindex Leads</button>
          <button onClick={() => runAction('reset-availability')} className="btn-ghost">Mark All Agents Available</button>
        </div>
      </div>
    </div>
  );
}

function Row({ label, ok }) {
  return (
    <div className="flex justify-between items-center">
      <span>{label}</span>
      <span className={`pill ${ok ? 'pill-sold' : 'pill-cold'}`}>{ok ? 'OK' : 'OFF'}</span>
    </div>
  );
}
